import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'Eu vendia meus potinhos a 5 reais e achavam caro. Apliquei o acabamento do guia e hoje vendo a 12 reais e a agenda vive cheia. Mudou meu negócio.',
  author: 'Juliana',
  role: 'Artesã'
}, {
  quote: 'Meus clientes sempre pediam desconto. Depois que mudei a apresentação seguindo o método, eles pagam o preço cheio e ainda elogiam a sofisticação.',
  author: 'Carla',
  role: 'Ateliê de Festas'
}, {
  quote: 'Achava que precisava de materiais caros para cobrar mais. O guia me mostrou que é tudo questão de detalhe. Lucrei 3x mais no último pedido.',
  author: 'Patrícia',
  role: 'Doceira'
}];
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 bg-white overflow-hidden" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 md:mb-16" data-id="element-268">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-stone-900 mb-4" data-id="element-269">
            Quem vende lembrancinhas já está usando
          </h2>
          <p className="text-sm md:text-base text-stone-600 max-w-3xl mx-auto" data-id="element-270">
            Pessoas que vendem artesanato e lembrancinhas aplicam o método para
            melhorar apresentação, vendas e percepção de valor.
          </p>
        </motion.div>

        <div className="relative" data-id="element-271">
          <div className="flex gap-6 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide" data-id="element-272">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 50
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.6
          }} className="flex-shrink-0 w-[85vw] md:w-[400px] bg-stone-50 p-6 md:p-8 rounded-2xl border border-stone-100 snap-center" data-id="element-273">
                <div className="flex gap-1 mb-4" data-id="element-274">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber-500 fill-amber-500" data-id="element-275" />)}
                </div>

                <p className="text-stone-700 leading-relaxed mb-6 italic text-base" data-id="element-276">
                  "{testimonial.quote}"
                </p>

                <div className="flex items-center gap-3" data-id="element-277">
                  <div className="w-10 h-10 bg-amber-200 rounded-full flex items-center justify-center font-bold text-amber-800" data-id="element-278">
                    {testimonial.author.charAt(0)}
                  </div>
                  <div data-id="element-279">
                    <p className="font-bold text-stone-900" data-id="element-280">
                      {testimonial.author}
                    </p>
                    <p className="text-sm text-stone-500" data-id="element-281">{testimonial.role}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <div className="flex justify-center gap-2 mt-6" data-id="element-282">
            {testimonials.map((_, index) => <div key={index} className="w-2 h-2 rounded-full bg-stone-300" data-id="element-283" />)}
          </div>
        </div>
      </div>

      <style jsx data-id="element-284">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </section>;
}